import { motion } from "framer-motion";
import Countdown from "./Countdown";

export default function CountdownSection() {
  return (
    <section
      id="countdown"
      data-testid="countdown-section"
      className="relative bg-[#0B1F3D] text-[#F5EBD9] py-16 sm:py-20 lg:py-24 overflow-hidden border-t border-[#F5EBD9]/10"
    >
      <div className="absolute inset-0 sunset-glow opacity-40 pointer-events-none" />

      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center mb-8 sm:mb-10"
        >
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-[#F5892E]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/70">
              Стартира на 24.10.2026
            </span>
            <span className="h-px w-10 bg-[#F5892E]" />
          </div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            Времето <span className="text-[#F5892E]">тече</span>.
          </h2>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          <Countdown />
        </div>
      </div>
    </section>
  );
}
